import { render, staticRenderFns } from "./InvRLAction.vue?vue&type=template&id=61f294f6"
import script from "./InvRLAction.vue?vue&type=script&lang=js"
export * from "./InvRLAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports